// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6aada5f0","667":"7c3e55d2","949":"a39cd34c"}[chunkId] + ".chunk.js";
};